import React, { useRef } from "react";
import CouponPopup from "./CouponPopup";
import bannerImg from "./images/frameworks.jpg";

const styles = {
  hero: {
    padding: "80px 20px",
    textAlign: "center",
    backgroundColor: "#f0f4f8",
  },
  title: {
    fontSize: "42px",
    fontWeight: "bold",
    marginBottom: "10px",
    color: "#0e283e",
  },
  subtitle: {
    fontSize: "20px",
    color: "#555",
    marginBottom: "20px",
    maxWidth: "700px",
    margin: "0 auto 20px",
  },
  subtitle2: {
    fontWeight: "bold",
  },
  button: {
    marginTop: "20px",
    padding: "12px 28px",
    fontSize: "16px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  jobSection: {
    padding: "60px 20px",
    textAlign: "center",
  },
  featuresContainer: {
    padding: "60px 30px",
    backgroundColor: "#fafafa",
    margin: "50px auto",
    borderRadius: "10px",
  },
  featureList: {
  fontSize: "16px",
  lineHeight: "1.8",
  paddingLeft: "20px",
  textAlign: "left",
  },
  featureNote: {
    marginTop: "20px",
    fontStyle: "italic",
    color: "#777",
  },
  templateSection: {
    padding: "60px 20px",
    textAlign: "center",
  },
  templateGrid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "20px",
    marginTop: "30px",
  },
  templateCard: {
    backgroundColor: "#fff",
    width: "220px",
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    transition: "transform 0.2s",
  },
  templateImg: {
    width: "100%",
    height: "280px",
    backgroundColor: "#ddd",
    borderRadius: "6px",
    marginBottom: "10px",
  },
  templateTitle: {
    fontWeight: "bold",
    fontSize: "16px",
    marginBottom: "6px",
  },
  templateDesc: {
    fontSize: "13px",
    color: "#666",
  },
  bannerWrapper: {
    textAlign: "center",
    marginTop: "60px",
  },
  banner: {
    width: "1000px",
    maxWidth: "100%",
    height: "300px",
    display: "block",
    margin: "40px auto",
    objectFit: "cover",
  },
};

function JobOptions({ onSelectJob }) {
  const jobRef = useRef();

  const scrollToJobs = () => {
    jobRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const templates = [
    {
      name: "Template 1",
      desc: "Clean layout with blue highlights.",
      img: "https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator2.png",
    },
    {
      name: "Template 2",
      desc: "Elegant and formal design ideal for finance or academia.",
      img: "https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator5.png",
    },
    {
      name: "Template 3",
      desc: "Stylish and colorful for designers or artists.",
      img: "https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator3.png",
    },
    {
      name: "Template 4",
      desc: "Simple, easy-to-read layout with clear sections.",
      img: "https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator1.png",
    },
  ];

  return (
    <div>

      {/* Coupon Popup */}
      <CouponPopup />

      {/* Hero Section */}
      <div style={styles.hero}>
        <p style={styles.subtitle2}>
          Use Coupon Code : CRCTE and Get 90% OFF. Only for 0.2 USD
        </p>
        <h1 style={styles.title}>Build Your Resume in Minutes</h1>
        <p style={styles.subtitle}>
          Create a resume tailored to your job — no design or writing skills needed. Just pick a template, fill in your details, and download in minutes.
        </p>
        <button style={styles.button} onClick={scrollToJobs}>Get Started</button>
      </div>

      <div class="banner-wrapper" style={styles.bannerWrapper}>
        <a
          href="https://aiframeworks.xyz"
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "inline-block" }}
        >
          <img class="banner-img"
            src={bannerImg}
            alt="AI Frameworks"
            style={styles.banner}
          />
        </a>
      </div>

      {/* Job Role Section */}
      <div ref={jobRef} style={styles.jobSection}>
        <h2>Select a Job Role to Begin</h2>
        <p style={{ color: "#666", marginBottom: "20px" }}>
           Build a resume that aligns with your career goals
        </p>
        {["Supervisor", "Developer", "Designer", "Bank", "Software", "Data Scientist", "Engineer", "Consultant"].map((job) => (
          <button
            key={job}
            onClick={() => onSelectJob(job)}
            className="res-btn"
          >
            {job}
          </button>
        ))}
      </div>

      {/* Features Section */}
     <div style={styles.featuresContainer}>
        <h2 style={{ textAlign: "center", marginBottom: "30px" }}>
          Features
        </h2>
        <div class="features-sec">
          <ul>
            <li>
              ✅ <strong>Modern & Professional Resume Templates:</strong><br />
              Choose from various designs that suit different industries, experience levels, and personal styles that stand out.
            </li>
            <li>
              📄 <strong>One-Click PDF Downloads:</strong><br />
              Instantly export your resume in high-quality PDF format with a single click.
            </li>
            <li>
              🔒 <strong>100% Secure — Your Data Stays with You:</strong><br />
              We don’t sell or share your data. Everything is encrypted and safely stored — you control what stays or goes.
            </li>
            <li>
              🛠️ <strong>User-Friendly Interface:</strong><br />
              Easily fill in your information, choose a template, and generate a resume.
            </li>
          </ul>

          <div class="res-img">
            <img
              src="https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator1.png"
              alt="Resume templates"
            />
          </div>
        </div>
      </div>


      {/* Resume Templates Section */}
      <div style={styles.templateSection}>
        <h2>Explore Our Resume Templates</h2>
        <p style={{ color: "#666", maxWidth: "700px", margin: "0 auto" }}>
          Choose from a professionally designed resume templates to your career needs.
        </p>
        <div style={styles.templateGrid}>
           {templates.map((tpl) => (
            <div
              key={tpl.name}
              style={styles.templateCard}
            >
              <img src={tpl.img} alt={tpl.name} style={styles.templateImg} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default JobOptions;
